

const newsList: any[] = [
  {
    title: '米兰冬奥“双金”背后的AI密码：小冰科技AI教练“观君”陪伴空中技巧的八年',
    link: 'https://mp.weixin.qq.com/s/Uv73kn3inFad1CI05G39Bg',
    date: '2026-02-26',
  },
  {
    title: '钉钉联合小冰发布AI前台Hi1—AI时代的企业入口',
    link: 'https://mp.weixin.qq.com/s/qWMha-GymE97X3L52pjlig',
    date: '2025-12-24',
  },
  {
    title: '小冰科技赋能瑞众保险：数字人客服及首批保险代理人数字分身已上线',
    link: 'https://mp.weixin.qq.com/s/FzdCIn0CqkIvZ3Um1lPcvw',
    date: '2025-08-18',
  },
  {
    title: "中汇人寿首位数字员工e小汇：首次亮相即承担“重任”",
    link: "https://mp.weixin.qq.com/s/DbTyHE1FyIcYpEyWQREfUg",
    date: "2025-07-11",
  },
  {
    title: "港股首例！小冰科技赋能，德林控股首次管理层AI数字员工业绩发布会",
    link: "https://mp.weixin.qq.com/s/HfOB37XqtZ_E_NJn-60fpg",
    date: "2025-06-13",
  },
  {
    title: "IDC公布中国AI数字人市场份额，小冰排名领先",
    link: "https://mp.weixin.qq.com/s/5---cTfl3JJhEoT97lwq3Q",
    date: "2025-06-13",
  },
  {
    title: "中标率提升3倍，AI物业服务场景大模型问世",
    link: "https://mp.weixin.qq.com/s/vG5DQZnrtNv6pA0H-tuDrw",
    date: "2025-04-21",
  },
  {
    title: "小冰科技牵手阿里云 推动金融行业智能化转型",
    link: "https://mp.weixin.qq.com/s/K1Wi29mYZcM1e05M04raFA",
    date: "2025-03-31",
  },
  {
    title: "AI公务员（智能助手）上线，无锡经开区迎来“大动作”",
    link: "https://mp.weixin.qq.com/s/F7ZsWxt-3LjJgMQo4nbI1w",
    date: "2025-03-28",
  },
  {
    title: "再获典型案例！小冰“华润南京数智人”亮相",
    link: "https://mp.weixin.qq.com/s/qLkYHt2g6bKhF6EdCOYQrg",
    date: "2024-09-24",
  },
  {
    title: "钉钉与小冰共创建筑行业数字人“钉小筑”：赋能建筑行业数字化建设",
    link: "https://mp.weixin.qq.com/s/Rta2YuiZOxogwstr9nAQCg",
    date: "2024-08-26",
  },
  {
    title: "能力第一！小冰位居IDC MarketScape中国AI数字人产品领导者类别",
    link: "https://mp.weixin.qq.com/s/qupP19m0uLhBl0lIlfjk4Q",
    date: "2024-08-23",
  },
  {
    title:
      "小冰数字人开启全国招商：加入小冰，共赢数字人蓝海 MarketScape中国AI数字人产品领导者类别",
    link: "https://mp.weixin.qq.com/s/HBmCe6U-6hP_hoWppFY7mQ",
    date: "2024-07-18",
  },
  {
    title:
      "小冰AI数字员工升级：发布全新“零样本”技术、超千亿大模型基座及透影音画传输系统",
    link: "https://mp.weixin.qq.com/s/ydVirJQAVuQkpd6oRwuJBg",
    date: "2024-07-17",
  },
  {
    title: "钉钉与小冰共创数字人安琪，受邀主持中国（浙江）HR服务数智创新大会",
    link: "https://mp.weixin.qq.com/s/5UMQAf_JzQsMuXZaiXFcYQ",
    date: "2024-07-11",
  },
  {
    title: "中信出版集团与小冰公司联合打造“AI作者数字人”项目，交互数字人已上线",
    link: "https://mp.weixin.qq.com/s/5mntKtIMJi8LaQcF5DPukw",
    date: "2024-07-10",
  },
  {
    title:
      "小冰联合视美泰共创ShiMeta数字人解决方案：大模型加持，让每一个大屏终端都成为全新的交互载体",
    link: "https://mp.weixin.qq.com/s/huBvR696yBj_Njsbz3o8LA",
    date: "2024-06-21",
  },
  {
    title:
      "数字人短剧首登世界级舞台，小冰《〈上元灯彩图〉书中人》于北京国际电影节展出",
    link: "https://mp.weixin.qq.com/s/ESAOQUZ7NNU-R13hVSMWWA",
    date: "2024-04-19",
  },
  {
    title:
      "小冰AI数字员工平台获《中国虚拟数字人影响力指数报告》年度智能化先锋案例",
    link: "https://mp.weixin.qq.com/s/Q-At-aQTRehzTVJz6M8DLQ",
    date: "2024-04-02",
  },
  {
    title: "钉钉启动数智校园标杆校计划，联合小冰提供校长数字人",
    link: "https://mp.weixin.qq.com/s/OJLaLGnNcT8Tj9mUZdKS1g",
    date: "2024-02-29",
  },
  {
    title: "引流、变现、增长：小冰数字员工平台获评“最佳AI创新SaaS产品”",
    link: "https://mp.weixin.qq.com/s/WpH8G0V0FtyTIdU004aGyA",
    date: "2024-02-04",
  },
  {
    title: "钉钉×小冰：共同推出一键定制数字人，将在AI助理等领域全面合作",
    link: "https://mp.weixin.qq.com/s/ZJTWHw3SwEQmjP1KFgDs3g",
    date: "2024-01-10",
  },
  {
    title: "小冰公司已获大模型备案，数字员工迎来全面升级",
    link: "https://mp.weixin.qq.com/s/s3HJzq0AAsnGjIeY8uyOMQ",
    date: "2024-01-05",
  },
  {
    title: "北京人寿×小冰：数字人项目获“全球保险科技案例”奖",
    link: "https://mp.weixin.qq.com/s/wXUM_OZv4RE-IeedTo7VhA",
    date: "2023-12-25",
  },
  {
    title: "2023杭州国际音乐产业博览会开幕，小冰数字人引领大众体验AI魅力",
    link: "https://mp.weixin.qq.com/s/qptqZEyVCinxW-nshNtXiA",
    date: "2023-12-15",
  },
  {
    title: "小冰公司获“科技进步一等奖”",
    link: "https://mp.weixin.qq.com/s/22HGchYWdPh8wLE8IYtKvw",
    date: "2023-12-08",
  },
  {
    title: "创业酵母张丽俊数字分身：小冰数字员工技术全面支持高效高质量内容产出",
    link: "https://mp.weixin.qq.com/s/qjfcdEZd9sVUiAKNr-tChA",
    date: "2023-11-17",
  },
  {
    title:
      "小冰公司获评“2020-2023音乐科技创新企业”，持续稳定赋能音乐产业内容生产",
    link: "https://mp.weixin.qq.com/s/6DqH1_cFhnQv7xP4qbc_ow",
    date: "2023-11-07",
  },
  {
    title:
      "小冰“最佳保险客户体验创新奖”的背后：数字员工成保险营销获客“破局”之道",
    link: "https://mp.weixin.qq.com/s/yWM-_F7g0C92S__eT4yiJw",
    date: "2023-10-27",
  },
  {
    title: "财经评论家马红漫同款数字人，赋能企业打造短视频营销矩阵",
    link: "https://mp.weixin.qq.com/s/wjGJg7_pKwnwTQpD9b7_GA",
    date: "2023-10-25",
  },
  {
    title: "小冰数字员工技术全面赋能招商局集团获中国信通院数字人最高指标评级",
    link: "https://mp.weixin.qq.com/s/DAv4uU9t_4xp1xl73GYHiQ",
    date: "2023-09-27",
  },
  {
    title:
      "世界智能网联汽车大会：小冰智能座舱及数字员工，为用户提供温暖有趣的出行体验",
    link: "https://mp.weixin.qq.com/s/15pLcq2dxMjft12RfBOdhA",
    date: "2023-09-21",
  },
  {
    title:
      "2023中国数智保险生态大会召开，小冰数字员工获评“最佳保险客户体验创新奖”",
    link: "https://mp.weixin.qq.com/s/zwVwkM5BbEkboW7S0071Gg",
    date: "2023-09-20",
  },
  {
    title:
      "小冰联合量子行星为天马集团打造数字人“日不落”直播间，日销售额近七万元",
    link: "https://mp.weixin.qq.com/s/hRQ7lEBpBCIbiudS5jdvnA",
    date: "2023-09-04",
  },
  {
    title: "艾媒咨询“2023中国AI数字人企业实力榜”发布，小冰数字人丰富度位列第一",
    link: "https://mp.weixin.qq.com/s/s9PkxioKe7i8aHnRXCiJrQ",
    date: "2023-08-24",
  },
  {
    title:
      "小冰数字人ceeci受邀主持CEE2023深圳国际消费电子博览会开幕式，引领大众体验前沿科技",
    link: "https://mp.weixin.qq.com/s/_BZbhvEXBpV1dzjlMbpiaQ",
    date: "2023-08-23",
  },
  {
    title: "小冰数字人：宝洁2023 Digital Innovation Roadshow唯一数字人解决方案",
    link: "https://mp.weixin.qq.com/s/LAn-Z2BPM-2cF2f2d7RpzA",
    date: "2023-08-21",
  },
  {
    title: "销售额同比提升150%！小冰联合量子行星助力南康海悦家具高速增长",
    link: "https://mp.weixin.qq.com/s/GosbfkQ5jYqrCa7GbTqfMQ",
    date: "2023-08-08",
  },
  {
    title: "“刘建宏分身有术”被中国互联网协会评为“数字人场景应用典型案例”",
    link: "https://mp.weixin.qq.com/s/kPhfQuI8kfOX0IhYWV0QVQ",
    date: "2023-07-25",
  },
  {
    title: "GPT克隆人计划：AI数字员工“0元定制”再升级，火热预定中！",
    link: "https://mp.weixin.qq.com/s/ED6cx4hlLF6gIEOEbp0gig",
    date: "2023-05-22",
  },
  {
    title: "AIGC辅助时尚活动制作：主持、作曲、设计全面应用",
    link: "https://mp.weixin.qq.com/s/fREltBe-RlZWe5Hf7DiuFw",
    date: "2023-05-19",
  },
  {
    title: "小冰公司x遥望科技：共创直播电商行业人工智能新范式",
    link: "https://mp.weixin.qq.com/s/aG4LL0WsIuNKg07mAn-DIw",
    date: "2023-05-15",
  },
  {
    title: "AI数字员工“0元定制”开启！形象声音复刻全包括！！！",
    link: "https://mp.weixin.qq.com/s/n63KIjj7UMDKb1R509P3dg",
    date: "2023-04-21",
  },
  {
    title: "AI助力体育 ——「中国教育装备展」在即，先睹为快！",
    link: "https://mp.weixin.qq.com/s/dfXb6hqGPib2tZCGPRCPcQ",
    date: "2023-04-19",
  },
  {
    title: "AI助力体育 AI闯入艺术家腹地",
    link: "https://mp.weixin.qq.com/s/RQqsXm--sprR3Kj20sImIg",
    date: "2023-04-14",
  },
  {
    title: "用TikTok出海？等到2040也太太太远了~~",
    link: "https://mp.weixin.qq.com/s/BT0rpnEHAomowyirgmqaBw",
    date: "2023-04-06",
  },
  {
    title: "向春而行，小欧为伴",
    link: "https://mp.weixin.qq.com/s/cct32p8Lm1AIJwyvY7Dqkg",
    date: "2023-01-21",
  },
  {
    title: "招商局集团首位数字员工“招小影”背后的黑科技",
    link: "https://mp.weixin.qq.com/s/h0AMYSiZzdpUOWu1WGf2eA",
    date: "2022-11-22",
  },
  {
    title: "刘建宏数字孪生人亮相！全程报道卡塔尔世界杯",
    link: "https://mp.weixin.qq.com/s/-7R4udXx8KDM6Updhsv78w",
    date: "2022-11-21",
  },
  {
    title: "虚拟音乐人pink如何Hold住顶级秀场？",
    link: "https://mp.weixin.qq.com/s/8tg_uHeHSgjTyuKTB9jTXA",
    date: "2022-10-27",
  },
  {
    title: "解密冬奥虚拟主播：一周时间，如何复刻新“气象先生”冯殊？",
    link: "https://mp.weixin.qq.com/s/Mf7eoGCiIBS23tBYZIXPDw",
    date: "2022-10-21",
  },
  {
    title: "虚拟人进化论：以AI being跑赢AIGC八项全能",
    link: "https://mp.weixin.qq.com/s/-fdUWJrWWoO_65M8NkqLcw",
    date: "2022-10-11",
  },
  {
    title: "小冰携手万事利丝绸，人工智能成为定制化新零售的助推器",
    link: "https://mp.weixin.qq.com/s/yE86m8cx_oMggllLdRfhSw",
    date: "2022-09-20",
  },
  {
    title: "百亿预算买虚拟人？技术完整度是关键",
    link: "https://mp.weixin.qq.com/s/JR83MQSTjAv7n_dtZG99Qg",
    date: "2022-09-13",
  },
  {
    title: "有趣的灵魂与好看的皮囊，需要AI being的表里如一",
    link: "https://mp.weixin.qq.com/s/lmfOKU3y7hvmpms0myMknw",
    date: "2022-09-06",
  },
  {
    title: "小冰，智能座舱里的情感交互专家!",
    link: "https://mp.weixin.qq.com/s/1P91QNMz5K_t7-JSGxP4xw",
    date: "2022-08-23",
  },
  {
    title: "情感交互虚拟人，让智能座舱奔赴“新四化”",
    link: "https://mp.weixin.qq.com/s/QYUuP9bs4CayrTujlOQlVA",
    date: "2022-08-16",
  },
  {
    title: "小冰与广汽传祺深化合作，定制虚拟人主打情感交互",
    link: "https://mp.weixin.qq.com/s/BGfzh_QTAbeGKWy7W072kA",
    date: "2022-08-02",
  },
  {
    title: "冬奥里程碑背后的黑科技！小冰AI裁判与教练系统“观君”详解",
    link: "https://mp.weixin.qq.com/s/4iIZul-MNgFaNEyows4JsA",
    date: "2022-07-28",
  },
  {
    title: "小冰以AI技术，助力每日经济新闻打造全球首创24小时“AI财经电视”",
    link: "https://mp.weixin.qq.com/s/8MF8-9BIhsfBjS-sbmSCRQ",
    date: "2022-07-18",
  },
];
newsList.forEach((item, index) => {
  const cover = new URL(
    `./covers/img${newsList.length - index}.jpg`,
    import.meta.url
  ).href;
  const cover1 = new URL(`./covers/img${index + 1 + 1}.jpg`, import.meta.url)
    .href;
  item.img = cover || cover1;
});
const data = {
  newsList,
};
export default data;
